import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class ThemeCheckerStateController implements angular.IComponentController {

    static $inject = [];

    $onInit() {
        this.enableLegacyCode();
    }

    private enableLegacyCode() {
        const self = this;
        (() => {
            $(window).scroll(() => {
                const top = $(document).scrollTop();
                $('.splash').css({
                    'background-position': `0px -${(top / 3).toFixed(2)}px`
                });
                if (top > 50) {
                    $('#home > .navbar').removeClass('navbar-transparent');
                }
                else {
                    $('#home > .navbar').addClass('navbar-transparent');
                }
            });

            $('a[href=\'#\']').click(e => {
                e.preventDefault();
            });

            const $button = $('<div id=\'source-button\' class=\'btn btn-primary btn-xs\'>&lt; &gt;</div>').click(function () {
                let html = $(this).parent().html();
                html = self.cleanSource(html);
                $('#source-modal pre').text(html);
                $('#source-modal').modal();
            });

            $('.bs-component [data-toggle="popover"]').popover();
            $('.bs-component [data-toggle="tooltip"]').tooltip();

            $('.bs-component').hover(function () {
                $(this).append($button);
                $button.show();
            }, () => {
                $button.hide();
            });
        })();
    }

    private cleanSource(html: any) {
        let lines = html.split(/\n/);

        lines.shift();
        lines.splice(-1, 1);

        const indentSize = lines[0].length - lines[0].trim().length,
            re = new RegExp(` {${indentSize}}`);

        lines = lines.map(line => {
            if (line.match(re)) {
                line = line.substring(indentSize);
            }

            return line;
        });

        lines = lines.join('\n');

        return lines;
    }
}

export const wtThemeCheckerState: ComponentDefinition = {
    componentId: 'wtThemeCheckerState',
    controller: ThemeCheckerStateController,
    template: require('./themeCheckerState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
